import { Segmented } from 'antd';
import { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getFromStorage, storeInLocal } from '../../lib/storage';
import InviteHqPractitioner from '../../modules/SuperAdmin/components/pageComponents/OfficePracticum/InvitePractitioner/InvitePractitioner.page';
import OPCredentials from '../../modules/SuperAdmin/components/pageComponents/OfficePracticum/Credentials/OPCredentials.page';
import HQUserManagementPage from './HQUserManagement.page';
import OPTrialManagementPage from './OPTrialManagement.page';
import { useIsOP } from 'src/hooks/misc';

const HQSettings = () => {
  const isOP = useIsOP();
  const { settingsOrgValue } = useSelector((state) => state?.appointmentState);
  const isSuperAdmin = !!settingsOrgValue?.roles?.includes('superadmin');
  const [activeButton, setActiveButton] = useState(() => {
    return getFromStorage('hqSettingsSegment') || 'Invite Practitioner';
  });

  const buttons = useMemo(
    () => [
      { label: 'Invite Practitioner' },
      { label: 'User Management' },
      ...(isOP && isSuperAdmin ? [{ label: 'Trial Management' }] : []),
      ...(isOP ? [{ label: 'Credentials' }] : []),
    ],
    [isOP, isSuperAdmin]
  );

  const effectiveTab = buttons.some((b) => b.label === activeButton)
    ? activeButton
    : 'Invite Practitioner';

  const handleSegmentedTabChange = (value) => {
    setActiveButton(value);
    storeInLocal('hqSettingsSegment', value);
  };

  return (
    <div className={`page-wrapper`}>
      <div className="lg:flex gap-3 justify-between py-3 items-center ">
        <Segmented
          options={buttons.map((button) => ({
            label: button.label,
            value: button.label,
          }))}
          value={effectiveTab}
          onChange={(value) => {
            handleSegmentedTabChange(value);
          }}
        />
      </div>
      <div>
        {effectiveTab === 'Invite Practitioner' && (
          <InviteHqPractitioner isHqAccount={true} />
        )}
        {effectiveTab === 'User Management' && <HQUserManagementPage />}
        {effectiveTab === 'Trial Management' && isOP && (
          <OPTrialManagementPage />
        )}
        {effectiveTab === 'Credentials' && isOP && <OPCredentials />}
      </div>
    </div>
  );
};

export default HQSettings;
